import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FoehnAddressModule, FoehnIconsModule, SdkDictionaryModule } from '@dsivd/prestations-ng';

import { RecapSectionComponent } from './recap-section.component';

@NgModule({
    declarations: [RecapSectionComponent],
    imports: [CommonModule, SdkDictionaryModule, FoehnAddressModule, FoehnIconsModule],
    exports: [RecapSectionComponent]
})
export class RecapSectionModule {
}
